var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"custom-menu"},[_c('CustomMenu')],1),_c('div',{staticClass:"main-page"},[_c('div',{staticClass:"header-section"},[_c('HeaderSection')],1),_c('div',{staticClass:"nav-router-section"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }